import { Header } from 'Modules';

export const ErrorPage = () => {
  return (
    <section>
      <Header />
      <h1>ErrorPage</h1>
    </section>
  );
};